<template>
  <v-card class="elevation-12 mb-5">
    <v-card-title class="headline font-weight-regular blue-grey white--text">Mot clé&nbsp;<b>{{keyword.targetKeyword}} ({{keyword.frenchKeyword}})</b></v-card-title>
    <v-card-text>
      <v-container v-if="keyword.status === 'pending'">
        <v-layout align-center justify-center row fill-height>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-layout>
        <h2 class="font-weight-thin text-md-center my-4">Mot clé en cours de création</h2>
        <v-layout align-center justify-center row>
          <v-btn color="info text-md-center" @click.prevent="refresh">Raffraichir</v-btn>
          <v-btn color="error text-md-center" @click.prevent="deleteKeywordLocal">Supprimer</v-btn>
        </v-layout>
      </v-container>
      <template v-if="keyword.status === 'done'">
        <p>Créé le {{keyword.createdAt | formatDate('DD/MM/YYYY')}} à {{keyword.createdAt | formatDate('HH:mm')}}</p>
        <template>
          <v-data-table
            :items="keyword.articles"
            :headers="articleHeaders"
            class="elevation-1"
            hide-actions
          >
            <template v-slot:items="props">
              <td>{{ props.item.url }}</td>
              <td>{{ originalLength(props.item) }}</td>
              <td>{{ translatedLength(props.item) }}</td>
              <td>{{ props.item.status }}</td>
              <td>
                <span class="action">
                  <v-btn flat icon color="blue" @click.prevent.native="openLink(props.item.url)">
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <TranslateBtn :article="props.item" :projectId="keyword.projectId"></TranslateBtn>
                  <v-btn flat icon color="cyan"
                         v-if="props.item.status !== 'googleOk'"
                         :to="{ name: 'Article', params: { articleId: props.item.id }}">
                      <v-icon>edit</v-icon>
                  </v-btn>
                </span>
              </td>
            </template>
          </v-data-table>
        </template>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import get from 'lodash/get';
  import TranslateBtn from "../components/TranslateBtn";

  export default {
    components: { TranslateBtn },
    props: ['keyword', 'refresh', 'deleteKeyword'],
    data() {
      return {
        articleHeaders: [
          { text: 'Url', value: 'url' },
          { text: 'Nombre de mots (VO)', value: 'originalContentLength' },
          { text: 'Nombre de mots (VF)', value: 'originalContentLength' },
          { text: 'Statut', value: 'status' },
          { text: '', sortable: false },
        ],
      };
    },
    methods: {
      originalLength(item) {
        return get(item, 'originalContentLength', 0);
      },
      translatedLength(item) {
        return get(item, 'translatedContentLength', 0);
      },
      openLink(href) {
        const a = document.createElement('a');
        a.setAttribute('href', href);
        a.setAttribute('target', '_blank');
        a.click();
        a.remove();
      },
      deleteKeywordLocal() {
        this.deleteKeyword(this.keyword.id);
      }
    },
  }
</script>

<style scoped lang="scss">
  .action {
    display: flex;
    flex-direction: row;
    > button, a.v-btn {
      margin-left: 0;
      margin-right: 0;
    }
  }
</style>
